import { useCallback } from "react";
import { useReplacePage } from "./useReplacePage";
import { useCreatePaymentCallback } from "./useCreatePaymentCallback";

export const useAssignSubscriptionCallback = () => {
  const {
    getSuccessAssignSubscriptionCallbackUrl,
    getFailAssignSubscriptionCallbackUrl,
    getInitialPaymentCallbackUrl,
  } = useCreatePaymentCallback();
  const replaceTo = useReplacePage();

  const successCallback = useCallback(() => {
    const okUrl = getSuccessAssignSubscriptionCallbackUrl();
    okUrl && replaceTo(okUrl, false);
  }, [replaceTo, getSuccessAssignSubscriptionCallbackUrl]);

  const failCallback = useCallback(
    (offerId?: string, voucherCode?: string) => {
      const assignSubscriptionFailUrl = getFailAssignSubscriptionCallbackUrl(
        offerId,
        voucherCode
      );
      assignSubscriptionFailUrl && replaceTo(assignSubscriptionFailUrl);
    },
    [replaceTo, getInitialPaymentCallbackUrl]
  );

  return {
    successCallback,
    failCallback,
  };
};
